﻿export class RuntimeErrorOccurred {
    static eventName() { return 'RuntimeErrorOccurred' }
    eventName = RuntimeErrorOccurred.eventName;
    constructor(public message?: any) { }
}